import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  FooterComponent,
  GlobalMessageComponent,
  HeaderComponent,
  UserTypeModalComponent,
} from '@boels/components';
import { RouterModule } from '@angular/router';
import { ModalService, UserTypeService, WindowRef } from '@boels/helpers';
import { BoelsUserTypeEnum } from '@boels/models';
import { take } from 'rxjs';

@Component({
  selector: 'boels-root',
  imports: [
    RouterModule,
    GlobalMessageComponent,
    HeaderComponent,
    FooterComponent,
  ],
  template: ` <boels-header></boels-header>
    <boels-global-message class="-default"></boels-global-message>
    <main>
      <router-outlet></router-outlet>
    </main>
    <boels-footer></boels-footer>`,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      min-height: 100vh;

      boels-footer {
        flex: 1;
      }

      main {
        min-height: 475px;
      }

      main:has(boels-language-selector-page) ~ boels-footer {
        flex: 0;
      }
    }
  `,
})
export class AppComponent implements OnInit {
  #platformId = inject(PLATFORM_ID);
  #winRef = inject(WindowRef);
  #userTypeService = inject(UserTypeService);
  #modalService = inject(ModalService);

  title = 'shell';

  ngOnInit() {
    if (isPlatformBrowser(this.#platformId)) this.initializeUserType();
  }

  /**
   * Initialize user type if user type is not selected open modal
   */
  private initializeUserType(): void {
    if (
      this.#winRef.nativeWindow &&
      this.#winRef.location?.pathname !== '/countryselection'
    ) {
      if (!this.#userTypeService.isUserTypeSelected()) {
        const dialogRef = this.#modalService.open(
          UserTypeModalComponent,
          {
            disableClose: true,
            panelClass: 'modal-xs',
          },
          false,
        );
        dialogRef
          .afterClosed()
          .pipe(take(1))
          .subscribe((userType) => {
            this.#userTypeService.setUserType(userType as BoelsUserTypeEnum);
          });
      }
    }
  }
}
